// extracted by mini-css-extract-plugin
export default {"header":"MyClinic_header__mAq2M","logo":"MyClinic_logo__mBfkc"};